/* eslint formatjs/no-literal-string-in-jsx: "error" */
import React, { FormEvent, useEffect, useState } from "react"
import { Container, FlexContainer, H1, Text, Modal, Stack, Button } from "@carrotfertility/carotene"
import { LocationPicker } from "../location-picker/LocationPicker"
import { useGetLocationDetails } from "../../hooks/useGetLocationDetails"
import { useHistory } from "react-router-dom"
import {
  ProviderFinderParam,
  RedirectToProviderFinderURL,
  getProviderFinderSearchURL
} from "../../utils/providerFinderSearchUrl"
import { useUserContext } from "../../context/UserContext"
import { useBroadAreaContext } from "../../context/BroadAreaContext"
import { FormattedMessage } from "react-intl"

interface ChangeLocationModalProps {
  open: boolean
  setOpen: (inputValue: boolean) => void
}

export const ChangeLocationModal = ({ open, setOpen }: ChangeLocationModalProps): JSX.Element => {
  const [locationPickerValue, setLocationPickerValue] = useState("")
  const [searchLocation, setSearchLocation] = useState(null)
  const { data: locationDetails, isFetching, isError } = useGetLocationDetails(searchLocation)
  const history = useHistory()
  const { companyCountryCode } = useUserContext()
  const { setBroadAreaSearched } = useBroadAreaContext()

  const params = new URLSearchParams(history.location.search)
  const radiusInKm = params.get(ProviderFinderParam.RadiusInKm)
  const isNewSearchDetailsLoaded = searchLocation && !isFetching && !isError
  const carrotPartner = params.get(ProviderFinderParam.CarrotPartner) === "true"
  const providerType = params.get(ProviderFinderParam.ProviderType)

  const newSearchURL = isNewSearchDetailsLoaded
    ? getProviderFinderSearchURL({
        searchLocation,
        locationDetails,
        radiusInKm,
        companyCountryCode,
        carrotPartner,
        providerType
      })
    : null

  useEffect(() => {
    if (isNewSearchDetailsLoaded) {
      setBroadAreaSearched(locationDetails?.isBroadArea)
    }
  }, [isNewSearchDetailsLoaded, setBroadAreaSearched, locationDetails?.isBroadArea])

  const handleSubmit = (event: FormEvent): void => {
    event.preventDefault()
    setSearchLocation(locationPickerValue)
    setOpen(false)
  }

  return (
    <>
      <RedirectToProviderFinderURL url={newSearchURL} />
      <Modal open={open} onClose={() => setOpen(false)} showClose>
        <Stack spacing="small" stack="large">
          <Container sx={{ borderBottom: "solid 1px #dbdad7" }} padding=" 0 48px 34px 48px">
            <H1 padding="49px 0 8px 0">
              <FormattedMessage defaultMessage="Location" />
            </H1>
            <Text color="black60">
              <FormattedMessage defaultMessage="Where would you like to find a provider?" />
            </Text>
          </Container>
          <Container padding="20px 48px  0 48px">
            <form onSubmit={handleSubmit}>
              <LocationPicker
                onInputChange={setLocationPickerValue}
                placeholderText="Address, city, state, or zip code"
              />
              <FlexContainer justifyContent="flex-end">
                <Button type="submit" style={{ marginTop: "48px", marginBottom: "12px" }}>
                  <FormattedMessage defaultMessage="Update location" />
                </Button>
              </FlexContainer>
            </form>
          </Container>
        </Stack>
      </Modal>
    </>
  )
}
